import { sendAsyncAction } from '../../core/async.js';

function replyToFriendMessageByIndex(index, msg) {
    return sendAsyncAction({
        actionId: 'replyToSteamFriend',
        index,
        msg,
    });
}

export { replyToFriendMessageByIndex };
//# sourceMappingURL=replyToFriendMessageByIndex.js.map
